import React from 'react';
import {useIntl} from 'react-intl';

import Button from '../../../Button';

import {IPaginatedContentButtonProps} from './IPaginatedContentButton';
import messages from './messages';

import styles from './PaginatedContentButton.module.scss';

const PaginatedContentButton = ({isLoading, handleLoadMore}: IPaginatedContentButtonProps) => {
	const intl = useIntl();

	return (
		<div className={styles['paginated-content__btn-wrapper']}>
			<Button variant="secondary" onClick={handleLoadMore} loading={isLoading}>
				{intl.formatMessage(messages.loadMore)}
			</Button>
		</div>
	);
};

export default PaginatedContentButton;
